import { AxiosInstance } from 'axios';
import { PhotoBasePriceRepository } from '~/model/repository/manager/parentSales/PhotoBasePriceRepository';

export default (Repository: AxiosInstance) => (): PhotoBasePriceRepository => ({
  get(facilityId: number) {
    return Repository.get(`/memories-api/v1/admin/base-price-settings/${facilityId}`);
  },
});
